/**
 * Lab Report Integration
 * Fetches lab report URL from Shopify metaobject index based on product SKU (internal_reference)
 */

(function() {
    'use strict';

    const INDEX_ELEMENT_ID = 'cwc-active-lab-report-index';

    /**
     * Read active lab report index injected by Liquid
     * Expected format:
     * {
     *   "SKU123": "/metaobjects/cwc_lot_report/....",
     *   "SKU456": "/metaobjects/cwc_lot_report/...."
     * }
     */
    function getActiveReportIndex() {
        const indexEl = document.getElementById(INDEX_ELEMENT_ID);
        if (!indexEl) {
            return {};
        }

        try {
            return JSON.parse(indexEl.textContent || '{}');
        } catch (error) {
            console.error('Invalid lab report index JSON:', error);
            return {};
        }
    }

    function normalizeSku(sku) {
        return (sku || '').trim().toUpperCase();
    }

    /**
     * Initialize lab report functionality when DOM is ready
     */
    function initLabReport() {
        const skuElement = document.querySelector('.variant-sku');
        const labReportLink = document.querySelector('.lab-report-link');

        if (!skuElement || !labReportLink) {
            console.log('Lab report elements not found on this page');
            return;
        }

        const sku = normalizeSku(skuElement.textContent);

        if (!sku) {
            hideLabReportLink(labReportLink);
            console.log('No SKU found for this product');
            return;
        }

        console.log('Checking active lab report for SKU:', sku);

        // Fetch report URL from Shopify-injected index
        fetchLabReportUrl(sku)
            .then(reportUrl => {
                if (reportUrl) {
                    labReportLink.href = reportUrl;
                    labReportLink.target = '_blank';
                    labReportLink.rel = 'noopener noreferrer';
                    labReportLink.textContent = 'View Lab Test Reports';
                    labReportLink.style.display = 'inline-block';
                    labReportLink.style.color = '#0066CC';
                    labReportLink.style.textDecoration = 'underline';
                    labReportLink.style.cursor = 'pointer';
                    console.log('Lab report available:', reportUrl);

                    // Prevent duplicate listeners
                    labReportLink.onclick = function(e) {
                        e.preventDefault();
                        window.open(reportUrl, '_blank', 'noopener,noreferrer');
                    };
                } else {
                    // Requirement: show option ONLY when found
                    hideLabReportLink(labReportLink);
                    console.log('No active lab report available for SKU:', sku);
                }
            })
            .catch(error => {
                console.error('Error fetching lab report:', error);
                hideLabReportLink(labReportLink);
            });
    }

    function hideLabReportLink(labReportLink) {
        if (!labReportLink) return;
        labReportLink.removeAttribute('href');
        labReportLink.removeAttribute('target');
        labReportLink.removeAttribute('rel');
        labReportLink.onclick = null;
        labReportLink.style.display = 'none';
    }

    /**
     * Fetch lab report URL from Shopify index (no API call)
     * @param {string} sku - Product SKU (internal_reference)
     * @returns {Promise<string|null>} Report URL or null if not available
     */
    async function fetchLabReportUrl(sku) {
        const index = getActiveReportIndex();
        const reportUrl = index[normalizeSku(sku)] || null;
        return reportUrl;
    }

    /**
     * Handle variant changes
     * Update lab report link when user selects different variant
     */
    function handleVariantChange() {
        const variantSelects = document.querySelectorAll('variant-selects, variant-radios');

        variantSelects.forEach(element => {
            element.addEventListener('change', () => {
                // Wait for SKU to update
                setTimeout(() => {
                    initLabReport();
                }, 120);
            });
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initLabReport();
            handleVariantChange();
        });
    } else {
        initLabReport();
        handleVariantChange();
    }

    // Re-initialize on Shopify section load (for theme editor)
    document.addEventListener('shopify:section:load', () => {
        initLabReport();
        handleVariantChange();
    });

})();